import { Observable, of } from 'rxjs';
import { DataSourceAdapter } from './data-source-adapter.interface';

/**
 * Adapter for static array data.
 * Use for small, fixed datasets that don't change.
 *
 * Sorting and filtering are handled client-side by MatTableDataSource.
 *
 * @example
 * ```ts
 * // Usually auto-created by resolveDataSource:
 * [dataSource]="[{ id: 1, name: 'Item 1' }, { id: 2, name: 'Item 2' }]"
 *
 * // Or manually:
 * const adapter = new StaticDataSource(myItems);
 * ```
 *
 * @template T - Row data type
 */
export class StaticDataSource<T> implements DataSourceAdapter<T> {
  readonly type = 'static' as const;

  constructor(private readonly data: T[]) {}

  connect(): Observable<T[]> {
    return of(this.data);
  }

  disconnect(): void {
    // No cleanup needed - static data has no subscriptions
  }
}
